<dialog class="m-dialog -floating-shadow-s -floating sm-max:tw-mx-4" #dialog>
  @if(closeButtonWithoutHeader$ | async){
  <bosch-ui-button [type]="buttonType.Close" (click)="close()" class="tw-ml-auto tw-z-10"></bosch-ui-button>
  } @if(dialogService.hasTitle$ | async){ @if(config.type){
  <div
    class="m-dialog__remark"
    [class.--info]="config.type === 'info'"
    [class.--success]="config.type === 'success'"
    [class.--warning]="config.type === 'warning'"
    [class.--error]="config.type === 'error'"
  ></div>
  }
  <div class="m-dialog__header">
    <div class="m-dialog__title">
      <ng-container #dialogTitle></ng-container>
    </div>
    @if(config.hasCloseButton){
    <bosch-ui-button [type]="buttonType.Close" (click)="close()" class="tw-ml-auto"></bosch-ui-button>}
  </div>
  <hr class="a-divider" />
  }

  <div class="m-dialog__content tw-flex tw-flex-col" [class.-tw-mt-10]="closeButtonWithoutHeader$ | async">
    @if (dialogService.hasHeadline$ | async){
    <div class="m-dialog__headline" [class.tw-mr-5]="closeButtonWithoutHeader$ | async">
      <ng-container #dialogHeadline></ng-container>
    </div>
    }

    <div class="m-dialog__body tw-overflow-auto">
      <ng-container #dialogBody></ng-container>
    </div>
    @if(dialogService.hasActions$ | async){
    <div class="m-dialog__actions">
      <ng-container #dialogActions></ng-container>
    </div>
    }
  </div>
</dialog>
